var React = require('react');

function I (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 0a6 6 0 110 12A6 6 0 016 0zM5 6v4h2V6H5zm-.25-3a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z","fill":"currentColor"}));
}

I.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = I;

I.default = I;
